import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'app-toolbar-charts-section',
    templateUrl: './toolbar-charts-section.component.html',
    styleUrls: ['./toolbar-charts-section.component.scss'],
    standalone: false
})
export class ToolbarChartsSectionComponent {
  @HostBinding('class') classes = 'flex-column';
}
